module.exports = __webpack_public_path__ + "static/img/1a (8).81252697.png";